/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPharmacy } from 'app/shared/model/pharmacy.model';
import { IPharmacySuppliers } from 'app/shared/model/pharmacy-suppliers.model';
import { IPharmacist } from 'app/shared/model/pharmacist.model';
import { VendorReturnStatus } from 'app/shared/model/enumerations/vendor-return-status.model';

export interface IPharmacyReturnBill {
  id?: string;
  billNumber?: string | null;
  billDate?: number | null;
  claimAmount?: number | null;
  totalCost?: number | null;
  discount?: number | null;
  active?: boolean | null;
  cursor?: number | null;
  timestampentry?: number | null;
  microSec?: number | null;
  lastUpdated?: number | null;
  cgst?: number | null;
  sgst?: number | null;
  status?: keyof typeof VendorReturnStatus | null;
  printed?: boolean | null;
  printCount?: number | null;
  pharmacy?: IPharmacy | null;
  supplier?: IPharmacySuppliers | null;
  processedBy?: IPharmacist | null;
}

export const defaultValue: Readonly<IPharmacyReturnBill> = {
  active: false,
  printed: false,
};
